import { showErrorPopup } from '@attensi/error-popup'
import { getEnv as _getEnv, type ServerConfig } from '@attensi/frontend-server'

export const getEnv = <Config extends ServerConfig>(config: Config) => {
  return _getEnv({ config, getLocalEnv, onMissingKeys })
}

const getLocalEnv = (key: string) => {
  // This needs to be split up into two lines.
  // Combining them into import.meta.env[key] will crash when there aren't any environment variables. Likely a bug in vite.
  const env = import.meta.env
  return env[key]
}

const onMissingKeys = (keys: string[]) => {
  for (const key of keys) {
    const error = new Error(`${key} is missing from environment`)
    showErrorPopup({ error, skipLandingPage: true })
  }
}
